<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/wgptSessionStorage';
import SessionStorage from 'shared/helpers/sessionStorage';

import Button from 'next/button/Button.vue';
import ViewWrapper from './ViewWrapper.vue';

const { t } = useI18n();
const store = useStore();

const setupCompleteSrc = '/dashboard/images/onboarding/wgpt_setup_complete.svg';

const completeOnboarding = async () => {
  try {
    await store.dispatch('wgptOnboarding/complete');
  } finally {
    SessionStorage.set(SESSION_STORAGE_KEYS.WIDGET_OPEN_ON_LOAD, true);
    window.location.assign('/');
  }
};
</script>

<template>
  <ViewWrapper>
    <div class="flex flex-col items-center text-center space-y-4">
      <img
        :src="setupCompleteSrc"
        alt="Setup complete"
        class="h-44 w-auto mx-auto object-contain"
      />
      <div class="space-y-2 min-h-[8rem]">
        <h2 class="text-lg font-semibold text-n-slate-12">
          {{ t('WGPT_ONBOARDING.SETUP_COMPLETE.TITLE') }}
        </h2>
        <p class="text-sm text-n-slate-11 leading-relaxed max-w-sm mx-auto">
          {{ t('WGPT_ONBOARDING.SETUP_COMPLETE.DESCRIPTION') }}
        </p>
      </div>
    </div>

    <template #actions>
      <Button
        lg
        :label="t('WGPT_ONBOARDING.AI_AGENT.CTA')"
        class="sm:ms-auto"
        @click="completeOnboarding"
      />
    </template>
  </ViewWrapper>
</template>
